// ** Router Import
import Router from './router/Router';
import axios from 'axios';
import * as Yup from 'yup';
import locale from './configs/yupConfig';
import NiceModal from '@ebay/nice-modal-react';
import ModalSeleccionarModulo from './components/Modal/ModalSeleccionarModulo';
import LoadingModal from './views/FichasActivas/NuevaFicha/Modals/LoadingModal';

Yup.setLocale(locale);

const App = (props) => <Router />;

export const biometricInstance = axios.create({
	baseURL: process.env.REACT_APP_BIOMETRICS_REST_URL || 'http://localhost:9001',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	}
});

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

NiceModal.register('seleccionar-mi-modulo', ModalSeleccionarModulo);
NiceModal.register('modal-loading', LoadingModal);

export default App;
